module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_1.a3074ece.svg";